import service from '@/api/newsletter/periodical';
import {handleError} from '@/state/generators/helpers';

export const state = {
    audienceLoading: false,
    audience: [],
    service: service('newsletters/periodicals')
}

export const getters = {
    loading: function (state) {
        return !!state.loading
    },
    audience: function (state) {
        return state.audience
    },
}

export const mutations = {
    'SET_AUDIENCE_LOADING': function (state, boolean = true) {
        state.audienceLoading = boolean
    },

    'SET_AUDIENCE': function (state, list) {
        state.audience = list
    },
}

export const actions = {
    audience: function ({commit, state}, {id, query}) {
        commit('app/SET_LOADING', true, {root: true});
        commit('SET_AUDIENCE_LOADING', true);

        return state.service.audience(id, query).then(response => {
            commit('SET_AUDIENCE', response.data);
            commit('app/SET_LOADING', false, {root: true});
            commit('SET_AUDIENCE_LOADING', false);
            return response.data;
        }).catch((e) => {
            handleError(e, commit);
        })
    }
}
